import React, { useEffect, useState } from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { ServiceTypes } from 'constants/ServiceTypes';
import Loader from 'components/loader/Loader';
import { TeamStore } from 'stores/TeamStore';
import { observer } from 'mobx-react-lite';
import { History } from 'history';
import moment from 'moment';
import { TeamSelector } from './Components/TeamSelector';
import { SessionVerificationStore } from '../../stores/SessionVerificationStore';
import { Content, InputWrapper, PageTitle, SessionCard, SessionsWrapper, TeamWrapper } from './styles/SessionsStyles';
import { Button, DatePicker } from '@trackman/web-shared-components';

export interface IProps {
  history: History;
}
export const Sessions: React.FC<IProps> = observer((props) => {
  const teamStore = useInjection<TeamStore>(ServiceTypes.TeamStore);
  const sessionVerificationStore = useInjection<SessionVerificationStore>(ServiceTypes.SessionVerificationStore);
  const [selectedTeamId, setSelectedTeamId] = useState<string | undefined>();
  const [date, setDate] = useState<Date | undefined>();
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    setDate(moment().add(-1, 'day').toDate());
    sessionVerificationStore.setSessions([]);
  }, []);

  return (
    <div className='page'>
      <div className='container'>
        <SessionsWrapper>
          {teamStore.isLoading ? (
            <Loader center size='large' />
          ) : (
            <>
              <PageTitle>Search for sessions</PageTitle>
              <SessionCard>
                <Content>
                  <InputWrapper>
                    <DatePicker
                      label='Session date'
                      onChange={(day: any): void => {
                        if (day) {
                          setDate(day.$d);
                        }
                      }}
                      value={date}
                    />
                    <TeamWrapper>
                      <TeamSelector
                        isError={false}
                        inputValue={inputValue}
                        setInputValue={setInputValue}
                        label='Team'
                        onSelectionChange={(selectedTeam): void => {
                          setSelectedTeamId(selectedTeam ? selectedTeam.id : undefined);
                        }}
                        isDisabled={teamStore.isLoading}
                      />
                    </TeamWrapper>
                  </InputWrapper>
                  <Button
                    data-test='session-search-btn'
                    intent='primary'
                    label='Search'
                    disabled={!date}
                    onClick={(): void => {
                      props.history.push(`search/teamId/${selectedTeamId!}/date/${moment(date).format('YYYY-MM-DD')}`);
                    }}
                  />
                </Content>
              </SessionCard>
            </>
          )}
        </SessionsWrapper>
      </div>
    </div>
  );
});
